<script lang="ts" setup>
import GoodHabitsCarousel from '../GoodHabitsCarousel/GoodHabitsCarousel.vue'
import { useKeyActivities } from '@/domains/esg/composables/content/useKeyActivities'

const { isMobile } = useBSBreakpoints()
const { goodHabitsItems } = useKeyActivities()
const fairplayImg = computed(() => isMobile.value ? '/images/key-activities/fairplay-warsaw-spire__m.webp' : '/images/key-activities/fairplay-warsaw-spire.webp')
</script>

<template>
  <UiSection
    id="fairplay"
    class="fairplay"
    color="white"
  >
    <div class="section__container">
      <div class="section__row section__row--1">
        <div class="section__col">
          <img
            class="fairplay__logo"
            :alt="$t('keyActivities.fairplay.header')"
            src="/images/key-activities/fairplay-logo.png"
          >

          <UiHeader
            subheader-size="h8"
            :position="'center'"
            :header="$t('keyActivities.fairplay.header')"
            :subheader="$t('keyActivities.fairplay.subheader')"
          />
        </div>
      </div>

      <div class="section__row ">
        <div class="section__col">
          <TextWithImage
            id="bs-office"
            class="fairplay__bs-office"
            header=""
            :text="$t('keyActivities.fairplay.text1')"
            :text-second="$t('keyActivities.fairplay.text2')"
            :image="fairplayImg"
          />
        </div>
      </div>

      <div class="section__row">
        <div class="section__col">
          <h3
            class="fairplay__heading"
            v-html="$t('keyActivities.fairplay.text3')"
          />
        </div>
      </div>
      
      <div class="section__row section__row--4">
        <div class="section__col section__col--carousel">
          <picture class="">
            <source
              media="(width < 768px)"
              srcset="/images/key-activities/training-good-habits__m.webp"
            >

            <source
              media="(width >= 768px)"
              srcset="/images/key-activities/training-good-habits.webp"
            >

            <img
              class=""
              src="/images/key-activities/training-good-habits.webp"
              :alt="$t('keyActivities.fairplay.imgAlt')"
            >
          </picture>

          <GoodHabitsCarousel :items="goodHabitsItems" />
        </div>
      </div>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
:deep(.text-with-image__layout) {
  margin-top: 0;
}

:deep(.ui-header) {
  margin-bottom: 4.8rem;
}

:deep(.ui-header__subheader) {
  @include h8;
  margin: 1.6rem auto;
}

.section__row {
  margin-bottom: 3.2rem;

  &--1 {
    margin-bottom: 2.4rem;
  }

  &--4 {
    align-items: center;
  }
}

.section__col {
  &--carousel {
    position: relative;
    max-width: 32.7rem;
    min-width: 32.7rem;
    min-height: 55rem;

    img {
      border-radius: 1.6rem;
    }
  }
}

.fairplay {
  padding-top: 3.2rem;
  padding-bottom: 2.4rem;

  :deep(.ui-header) {
    margin: 1.6rem auto;
  }

  :deep(.ui-header__subheader) {
    margin: 1.6rem auto;
    @include h10;
  }

  :deep(.text-with-image__img) {
    width: auto;
  }

  :deep(.text-with-image__text--second) {
    margin-bottom: 0;
  }

  &__logo {
    display: block;
    margin: 0 auto 1.6rem auto;
  }

  &__heading {
    @include h10;
    text-align: center;
  }

  &__bs-office {
    margin: 0;
    padding: 0;
  }
}

@include atXS {
  .section__row {
    &--4 {
      align-items: flex-start;
    }
  }

  .section__col {
    &--carousel {
      max-width: unset;
    }
  }
}

@include atM {
  .fairplay {
    padding-top: 12rem;
    padding-bottom: 12rem;

    :deep(.ui-header) {
      margin: 4.8rem auto;
    }

    :deep(.ui-header__subheader) {
      @include h8;
      margin: 4.8rem auto;
    }

    &__logo {
      margin: 0 auto 4.8rem auto;
    }

    &__heading {
      @include h8;
    }
  }

  .section__row {
    margin-bottom: 9.6rem;

    &--1 {
      margin-bottom: 4.8rem;
    }
  }

  .section__col {
    &--carousel {
      min-height: 72.2rem;

      img {
        width: 80%;
      }
    }
  }
}
</style>
